<template>
  <b-modal id="edit-ad-modal" title="Edit AD Rank" @show="onShow">
    <b-form-group label="Rank">
      <b-form-input
        v-model.number="rank"
        type="number"
        min="0"
        placeholder="Enter rank"
      />
    </b-form-group>
    <template #modal-footer="{close}">
      <b-row style="width:100%">
        <b-col md="6">
          <b-button block variant="danger" @click="close">
            Cancel
          </b-button>
        </b-col>
        <b-col md="6">
          <b-button
            block
            variant="primary"
            :disabled="submitting"
            @click="updateHandler(close)"
          >
            <BSpinner v-if="submitting" small />
            <span v-else>Update</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BButton,
  BSpinner,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
} from "bootstrap-vue";
import { ref, watch } from "@vue/composition-api";
import {
  errorNotification,
  successNotification,
} from "@/utils/toast-notifications";

export default {
  components: {
    BModal,
    BButton,
    BSpinner,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
  },
  props: {
    adId: {
      type: String,
      required: true,
    },
    currentRank: {
      type: Number,
      default: 0,
    },
    screen: {
      type: String,
      required: true,
    },
  },
  setup(props, ctx) {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const userCountry = userData?.country || "JO";

    const submitting = ref(false);
    const rank = ref(props.currentRank);

    const onShow = () => {
      rank.value = props.currentRank;
    };

    // Watch for changes in currentRank prop
    watch(
      () => props.currentRank,
      (newRank) => {
        rank.value = newRank;
      }
    );

    const updateHandler = async (closeFn) => {
      try {
        submitting.value = true;
        await ctx.root.$store.dispatch("ads/updateAd", {
          adId: props.adId,
          screen: props.screen,
          country: userCountry,
          rank: rank.value,
        });
        successNotification("Ad rank updated successfully");
        closeFn();
        ctx.emit("updated");
      } catch (error) {
        const errMsg = error?.response?.data?.error?.message;
        errorNotification(errMsg || "An error occurred while updating the ad");
      } finally {
        submitting.value = false;
      }
    };
    return {
      submitting,
      updateHandler,
      rank,
      onShow,
    };
  },
};
</script>

<style></style>
